import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../redux/reducers/rootReducer';

/**
 * Typed `useSelector` hook based on our `RootState`
 * @see https://react-redux.js.org/tutorials/typescript-quick-start#define-typed-hooks
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
